//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Icon from '@/js/vue/Icon';

export default {
  components: { Icon },
  props: {
    href: {
      type: String,
      default: '',
    },
    target: {
      type: String,
      default: '',
    },
  },
};
